import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import ProfileBackedCampaigns from '../pages/ProfileBackedCampaigns.vue';
import SearchInput from '../components/SearchInput.vue';
import ShippingModal from '../components/ShippingModal.vue';

class ProfileBackedCampaignsComponent {
  constructor({ container }) {
    this.app = null;
    this.container = container;
  }

  init() {
    this.app = createApp(ProfileBackedCampaigns);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    this.app.component('search-input', SearchInput);
    this.app.component('shipping-modal', ShippingModal);

    // Mount the Vue app to the specified container
    this.app.mount(this.container);
  }
}

export default ProfileBackedCampaignsComponent;